import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class DeactivatePatientUsecase {
  constructor(private readonly patientRepo: PatientRepository) {}

  async execute(patientUuid: string): Promise<SATResult<void, SATError>> {
    return this.patientRepo.deactivatePatient(patientUuid);
  }
}
